"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var owa_options_strings_1 = require("owa-strings/owa-options-strings");
function getInboxRuleMessageFlagOptions() {
    return [
        { value: 'Any', text: owa_options_strings_1.default.options_inboxRules_any },
        { value: 'Call', text: owa_options_strings_1.default.options_inboxRules_call },
        { value: 'DoNotForward', text: owa_options_strings_1.default.options_inboxRules_doNotForward },
        { value: 'FollowUp', text: owa_options_strings_1.default.options_inboxRules_followUp },
        { value: 'Forward', text: owa_options_strings_1.default.options_inboxRules_forward },
        { value: 'ForYourInformation', text: owa_options_strings_1.default.options_inboxRules_forYourInformation },
        { value: 'NoResponseNecessary', text: owa_options_strings_1.default.options_inboxRules_noResponseNecessary },
        { value: 'Read', text: owa_options_strings_1.default.options_inboxRules_read },
        { value: 'Reply', text: owa_options_strings_1.default.options_inboxRules_reply },
        { value: 'ReplyToAll', text: owa_options_strings_1.default.options_inboxRules_replyToAll },
        { value: 'Review', text: owa_options_strings_1.default.options_inboxRules_review },
    ];
}
exports.default = getInboxRuleMessageFlagOptions;
//# sourceMappingURL=getInboxRuleMessageFlagOptions.js.map


//////////////////
// WEBPACK FOOTER
// ./obj/options/config/mail/owa-inbox-rules-option/lib/actions/helpers/getInboxRuleMessageFlagOptions.js
// module id = 5199
// module chunks = 2